import React from 'react';

const Analytics = () => {
  return (
    <>
      <iframe
        title="Analytics Report"
        src="/report.html" // Adjust the path based on your folder structure
        style={{ width: '100%', height: '100vh', border: 'none' }}
      ></iframe>
    </>
  );
};

export default Analytics;
